import { render, staticRenderFns } from "./SFRadio.vue?vue&type=template&id=275a9396&lang=pug&"
import script from "./SFRadio.vue?vue&type=script&lang=ts&"
export * from "./SFRadio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports